import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EscalationMailDrop } from './escalation-mail-form-array';

@Injectable()
export class EscalationMailEmitter {
    public readonly $escalationMailDrop = new Subject<EscalationMailDrop>();
    constructor( ) {
    }

    public setMailDrop(mail: EscalationMailDrop) {
        this.$escalationMailDrop.next(mail);
    }
}
